module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "align-items-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v(" "), _c('md-text', [_vm._v("Back")])], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("To Do List")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Task")])], 1)], 1)], 1), _vm._v(" "), (_vm.showMain == true) ? _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.showMain == true) ? _c('div', [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Task Title")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.showStatus == false ? false : true,
      "id": "taskTitle",
      "name": "taskTitle"
    },
    model: {
      value: (_vm.agentColaderModel.taskTitle),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "taskTitle", $$v)
      },
      expression: "agentColaderModel.taskTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "isDisabled": _vm.showStatus == false ? false : true,
      "option-value": "clientId",
      "option-text": "clientName",
      "id": "clientId",
      "name": "clientName",
      "placeholder": "Select Client"
    },
    on: {
      "input": function($event) {
        _vm.getAssignmentData()
      }
    },
    model: {
      value: (_vm.agentColaderModel.fk_client_id),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "fk_client_id", $$v)
      },
      expression: "agentColaderModel.fk_client_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PODList,
      "isDisabled": _vm.showStatus == false ? false : true,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "id": "pickupId",
      "name": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'PODList');
        _vm.getAssignmentData()
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'PODList');
      }
    },
    model: {
      value: (_vm.agentColaderModel.fk_pod_id),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "fk_pod_id", $$v)
      },
      expression: "agentColaderModel.fk_pod_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AssignmentArrList,
      "isDisabled": _vm.showStatus == false ? false : true,
      "option-value": "allModuleId",
      "option-text": "mainSalesSeries",
      "id": "allModuleId",
      "name": "mainSalesSeries",
      "placeholder": "Select Assignment No."
    },
    model: {
      value: (_vm.agentColaderModel.fk_all_module_id),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "fk_all_module_id", $$v)
      },
      expression: "agentColaderModel.fk_all_module_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Assign To")]), _vm._v(" "), _c('multi-list-select', {
    attrs: {
      "list": _vm.userDataList,
      "isDisabled": _vm.showStatus == false ? false : true,
      "option-value": "userId",
      "option-text": "employeeName",
      "id": "mySelectId",
      "name": "mySelectName",
      "selected-items": _vm.itemsUsers,
      "placeholder": "select "
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "Disabled": _vm.showStatus == false ? false : true,
      "id": "taskDescription",
      "name": "taskDescription"
    },
    model: {
      value: (_vm.agentColaderModel.taskDescription),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "taskDescription", $$v)
      },
      expression: "agentColaderModel.taskDescription"
    }
  }), _vm._v(" "), (_vm.agentColaderModel.taskStatus == '2' || _vm.agentColaderModel.taskStatus == '3') ? _c('label', [_vm._v("Remarks & Quries")]) : _vm._e(), _vm._v(" "), (_vm.agentColaderModel.taskStatus == '2' || _vm.agentColaderModel.taskStatus == '3') ? _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "taskDescription1",
      "name": "taskDescription1"
    },
    model: {
      value: (_vm.agentColaderModel.taskRemarks),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "taskRemarks", $$v)
      },
      expression: "agentColaderModel.taskRemarks"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showStatus == true) ? _c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Task Status")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true) ? _c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.agentColaderModel.taskStatus),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "taskStatus", $$v)
      },
      expression: "agentColaderModel.taskStatus"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.descriptionList.length > 0) ? _c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning",
    staticStyle: {
      "-webkit-overflow-scrolling": "auto"
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "direct-chat-messages",
    attrs: {
      "id": "descriptionList"
    }
  }, _vm._l((_vm.descriptionList), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [(item.description != '') ? _c('div', [_c('div', {
      staticClass: "direct-chat-msg mt-2"
    }, [_c('div', {
      staticClass: "direct-chat-info clearfix"
    }, [_c('span', {
      staticClass: "direct-chat-name pull-left"
    }, [_vm._v(_vm._s(item.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "direct-chat-timestamp pull-right"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])]), _vm._v(" "), _c('span', {
      staticClass: "img-sm rounded-circle bg-primary text-white text-center text-avatar"
    }, [_vm._v(_vm._s(item.employeeName.slice(0, 1)))]), _vm._v(" "), _c('div', {
      staticClass: "direct-chat-text"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), (_vm.descriptionList.length <= 0 && item.description == '') ? _c('div', [_c('span', {
      staticClass: "direct-chat-name error text-muted"
    }, [_vm._v("Remarks & Queries will appear here if any.\n                                "), _c('hr')])]) : _vm._e()])
  }))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v(_vm._s(_vm.agentColaderModel.taskId != '' ? 'Update' : 'Add') + " Task")])], 1)])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    staticClass: "form-focus",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.payList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.donePendingFilter),
      callback: function($$v) {
        _vm.donePendingFilter = $$v
      },
      expression: "donePendingFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-end"
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.taskDataList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "taskId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "taskTitle",
      fn: function(row1) {
        return [(row1.item.taskStatus != '2') ? _c('b', {
          staticClass: "showMoreData",
          style: (row1.item.firstSeenByUserId == '0' ? 'color:red' : ''),
          on: {
            "click": function($event) {
              _vm.viewEdit(row1.item)
            }
          }
        }, [_vm._v(_vm._s(row1.item.taskTitle))]) : _c('b', [_vm._v(_vm._s(row1.item.taskTitle))]), _vm._v(" "), (row1.item.firstSeenByUserId == '0') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("not seen")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                Created By " + _vm._s(row1.item.employeeName) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("On " + _vm._s(_vm._f("moment")(row1.item.loginTime)))])]
      }
    }, {
      key: "taskStatus",
      fn: function(row11) {
        return [_c('b-badge', [_vm._v(_vm._s((row11.item.taskStatus == '0') ? 'Pending' : row11.item.taskStatus == '1' ? 'In-Progress' : row11.item.taskStatus == '2' ? 'Completed' : 'Query Raised'))]), _vm._v(" "), _c('br'), _vm._v(" "), (row11.item.firstSeenByUserId != '0') ? _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("\n                Task Seen on " + _vm._s(_vm._f("moment")(row11.item.firstSeenByUserDate)) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.lastUpdatedBy != '' && row11.item.lastUpdatedBy != null) ? _c('span', [_vm._v("\n                Last Updated By " + _vm._s(row11.item.lastUpdatedBy) + "\n                "), _c('br'), _vm._v("\n                on " + _vm._s(_vm._f("moment")(row11.item.updateTime)) + "\n              ")]) : _vm._e()]
      }
    }, {
      key: "assignedUsersName",
      fn: function(row5) {
        return [(row5.item.assignedUsersName != null) ? _c('div', _vm._l((row5.item.assignedUsersName.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "secondary"
            }
          }, [_vm._v(_vm._s(item1 == '' ? '-------' : item1))])], 1)])
        })) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f95be42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/toDoList/toDoList.vue
// module id = 2735
// module chunks = 0